export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/identity.js
// module id = ./node_modules/d3-shape/src/identity.js
// module chunks = 53